import { render, staticRenderFns } from "./MatTypeLineItem.vue?vue&type=template&id=5bc122e9&scoped=true&"
import script from "./MatTypeLineItem.vue?vue&type=script&lang=ts&"
export * from "./MatTypeLineItem.vue?vue&type=script&lang=ts&"
import style0 from "./MatTypeLineItem.vue?vue&type=style&index=0&id=5bc122e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc122e9",
  null
  
)

export default component.exports